import React from "react";
import AppPanel from "../../components/app-panel";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCartOutlined";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import VoicemailIcon from "@material-ui/icons/Voicemail";
import PaletteIcon from "@material-ui/icons/PaletteOutlined";
import CameraIcon from "@material-ui/icons/CameraOutlined";
// import DonutLargeIcon from "@material-ui/icons/DonutLarge";
import PeopleIcon from "@material-ui/icons/PeopleOutline";
import LocalMallIcon from "@material-ui/icons/LocalMallOutlined";
import LocalOfferIcon from "@material-ui/icons/LocalOfferOutlined";
import CategoryOutlinedIcon from "@material-ui/icons/CategoryOutlined";
import LocalHospitalOutlinedIcon from "@material-ui/icons/LocalHospitalOutlined";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import AllInboxOutlinedIcon from "@material-ui/icons/AllInboxOutlined";
import AssignmentIcon from '@material-ui/icons/Assignment';

const menuItems = [
    {
        title: "سفارشات",
        route: "/admin/orders",
        icon: <ShoppingCartIcon />,
    },
    {
        title: "هماهنگی‌ها",
        route: "/admin/coordination",
        icon: <PlaylistAddCheckIcon />,
    },
    {
        title: "درخواست موجودی",
        route: "/admin/req-glass",
        icon: <PlaylistAddCheckIcon />,
    },
    {
        title: "مشتریان",
        route: "/admin/customers",
        icon: <PeopleIcon />,
    },
    {
        title: "موجودی عینک‌ها",
        route: "/admin/glasses-stock",
        icon: <AllInboxOutlinedIcon />,
    },
    {
        title: "تغییرات گروهی",
        route: "/admin/change-group",
        icon: <AllInboxOutlinedIcon />,
    },
    {
        title: "مدل های قسطی",
        route: "/admin/installment",
        icon: <ShoppingCartIcon />,
    },
    { divider: true },
    // {
    //   title: "گزارشات",
    //   route: "/admin/reports",
    //   icon: <DonutLargeIcon />,
    // },
    // { divider: true },
    {
        title: "برندها",
        route: "/admin/brands",
        icon: <LocalOfferIcon />,
    },
    {
        title: "عینک‌ها",
        route: "/admin/glasses",
        icon: <VoicemailIcon style={{ transform: "rotate(180deg)" }} />,
    },
    {
        title: "اکسسوری‌ها",
        route: "/admin/accessories",
        icon: <LocalMallIcon />,
    },
    {
        title: "گروه‌های اکسسوری‌",
        route: "/admin/accessory-categories",
        icon: <CategoryOutlinedIcon />,
    },
    {
        title: "رنگ‌ها",
        route: "/admin/colors",
        icon: <PaletteIcon />,
    },
    {
        title: "دسته بندی رنگ‌ها",
        route: "/admin/color-categories",
        icon: <PaletteIcon />,
    },
    {
        title: "ویژگی های خاص",
        route: "/admin/special-features",
        icon: <PaletteIcon />,
    },
    {
        title: "عدسی‌ها",
        route: "/admin/lenses",
        icon: <CameraIcon />,
    },
    {
        title: "بیمه ها",
        route: "/admin/insurances",
        icon: <LocalHospitalOutlinedIcon />,
    },
    { divider: true },
    {
        title: "Redirect",
        route: "/admin/redirect",
        icon: <PaletteIcon />,
    },
    {
        title: "صفحه ها",
        route: "/admin/page-builder",
        icon: <PaletteIcon />,
    },
    {
        title: "فرم ها",
        route: "/admin/forms",
        icon: <PaletteIcon />,
    },
    {
        title: "کوپن تخفیف",
        route: "/admin/coupon",
        icon: <PaletteIcon />,
    },
    {
        title: "بلاگ",
        route: "/admin/blogs",
        icon: <LocalOfferIcon />,
    },
    {
        title: "تگ ها",
        route: "/admin/tags",
        icon: <AssignmentIcon />,
    },
    {
        title: "روش‌های ارسال",
        route: "/admin/shipping-methods",
        icon: <LocalShippingOutlinedIcon />,
    },
    {
        title: "سوالات پر تکرار",
        route: "/admin/faq",
        icon: <HelpOutlineOutlinedIcon />,
    },
    {
        title: "درباره ی ما",
        route: "/admin/about-us",
        icon: <HelpOutlineOutlinedIcon />,
    },
    {
        title: "قوانین و مقررات",
        route: "/admin/terms-conditions",
        icon: <HelpOutlineOutlinedIcon />,
    },
    {
        title: "ویژه ها",
        route: "/admin/specials",
        icon: <SettingsOutlinedIcon />,
    },
    {
        title: "مدیریت خانه",
        route: "/admin/main-page",
        icon: <SettingsOutlinedIcon />,
    },
    {
        title: "تبلیغات",
        route: "/admin/ads",
        icon: <AssignmentIcon />,
    },
    {
        title: "تنظیمات",
        route: "/admin/settings",
        icon: <SettingsOutlinedIcon />,
    },
];

const AdminPanel = ({ children }) => {
    return <AppPanel menuItems={menuItems}>{children}</AppPanel>;
};

export default AdminPanel;
